import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/retry.tsx
var Retry = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M4.25 14.6667C5.34507 17.7738 8.29983 20 11.773 20C16.1786 20 19.75 16.4183 19.75 12C19.75 7.58172 16.1786 4 11.773 4C8.8977 4 7.02891 5.30135 5.17465 7.5M4.76498 4V7.25C4.76498 7.66421 5.0998 8 5.51282 8H8.75345",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.76284 3C5.31371 3 5.76027 3.44772 5.76027 4V5.42391C7.37851 3.92227 9.22769 3 11.7731 3C16.7309 3 20.75 7.02944 20.75 12C20.75 16.9706 16.7309 21 11.7731 21C7.86296 21 4.53915 18.4941 3.30729 14.9999C3.12371 14.4792 3.39593 13.9079 3.91531 13.7238C4.43469 13.5398 5.00455 13.8127 5.18812 14.3334C6.14708 17.0536 8.73465 19 11.7731 19C15.6292 19 18.7551 15.866 18.7551 12C18.7551 8.13401 15.6292 5 11.7731 5C9.80419 5 8.37917 5.67948 6.999 7H8.75257C9.30344 7 9.75 7.44772 9.75 8C9.75 8.55228 9.30344 9 8.75257 9H5.51092C4.5469 9 3.76541 8.2165 3.76541 7.25V4C3.76541 3.44772 4.21198 3 4.76284 3Z",
		fill: "currentColor"
	})
});
//#endregion
export { Retry };
